import React, {useCallback} from 'react'
import {
  Redirect,
  Switch,
  useLocation,
  matchPath,
  useHistory,
  Route,
} from 'react-router-dom'
import {
  BreadcrumbsContextProvider,
  ErrorBoundary,
  PublishingContextProvider,
  useCurrentUserAnPCheck,
} from '@therms/react-modules'
import {AppLayoutContainer} from './modules/Layout/shared/AppLayoutContainer'
import {LOCATIONS_ROUTES} from '@src/modules/Locations/constants'
import LocationsRoutes from '@src/modules/Locations/router/Routes'
import {Loading} from '@therms/atalaya'
import {STATS_ROUTES} from '@src/modules/Stats/constants'
import StatsRoutes from '@src/modules/Stats/router/Routes.tsx'

function AppRouter() {
  const history = useHistory()
  const {pathname} = useLocation()
  const linkMatcher = useCallback(
    (link) => !!matchPath(pathname, { exact: true, path: link }),
    [pathname],
  )

  const canViewUserGps = useCurrentUserAnPCheck(
    (user) => user.anp.role.portal.access.viewUserGps,
  )

  return (
    <PublishingContextProvider
      showGpsCoords={!!canViewUserGps}
      isPublishing={false}
      showInternalContent={false}
    >
      <BreadcrumbsContextProvider
        isCurrentLinkMatcher={linkMatcher}
        onBack={history.goBack}
        onNavigate={history.push}
      >
        <AppLayoutContainer>
          <ErrorBoundary onResetError={() => window.location.reload()}>
            <React.Suspense fallback={<Loading overlay />}>
              <Switch>
                <Route path={LOCATIONS_ROUTES.__ROOT__}>
                  <LocationsRoutes />
                </Route>

                <Route path={STATS_ROUTES.__ROOT__} component={StatsRoutes} />

                <Redirect to={LOCATIONS_ROUTES.__ROOT__} />
              </Switch>
            </React.Suspense>
          </ErrorBoundary>
        </AppLayoutContainer>
      </BreadcrumbsContextProvider>
    </PublishingContextProvider>
  )
}

export {AppRouter}
